import React, { Component } from 'react'
import { Tag } from 'antd'
import { observer, inject } from 'mobx-react'
@inject((store: any) => {
    const { synonymsStore } = store
    return { synonymsStore }
})
@observer
class Keyword extends Component<any, any> {
    render() {
        const { keyword, synonymsStore } = this.props
        const backgroundColor = synonymsStore.compareKeyword === keyword ? '#ffd182' : 'white'
        return (
            <Tag
                onMouseOver={() => synonymsStore.toggleCompareKeyword(keyword)}
                onMouseOut={() => synonymsStore.toggleCompareKeyword(null)}
                style={{ margin: '0.2rem', backgroundColor }}
            >
                {keyword.replace('_', ' ')}
            </Tag>
        )
    }
}

export default Keyword
